import {ISegmentIdentifyAction} from './types';
import {SEGMENT_ACTION, SEGMENT_IDENTIFY} from '../../constants';

export const segmentIdentifyAction = (traits: any = {}): ISegmentIdentifyAction => ({
    type: SEGMENT_ACTION,
    case: SEGMENT_IDENTIFY,
    traits
});
